/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query"
import { mutationOptions, useMutation } from "@tanstack/react-query"

import fetch from "~/backend/axiosClient"
import type {
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "~/backend/axiosClient"

import type {
  ValidateBulkUpdatequest,
  ValidateBulkUpdatesponse,
} from "../types/ValidateBulkUpdate.ts"

export const validateBulkUpdatey = () =>
  [{ url: "/v1/product/validate-bulk-update" }] as const

export type ValidateBulkUpdatey = ReturnType<typeof validateBulkUpdatey>

/**
 * @description Validates CSV content and returns a preview of changes. Returns a validationId that must be used to confirm the updates.
 * @summary Validate bulk product updates (Step 1)
 * {@link /v1/product/validate-bulk-update}
 */
export async function validateBulkUpdate(
  data: ValidateBulkUpdatequest,
  config: Partial<RequestConfig<ValidateBulkUpdatequest>> & {
    client?: typeof fetch
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    ValidateBulkUpdatesponse,
    ResponseErrorConfig<Error>,
    ValidateBulkUpdatequest
  >({
    method: "POST",
    url: `/v1/product/validate-bulk-update`,
    data: requestData,
    ...requestConfig,
  })
  return res
}

export function validateBulkUpdatetions(
  config: Partial<RequestConfig<ValidateBulkUpdatequest>> & {
    client?: typeof fetch
  } = {}
) {
  const mutationKey = validateBulkUpdatey()
  return mutationOptions<
    ResponseConfig<ValidateBulkUpdatesponse>,
    ResponseErrorConfig<Error>,
    { data: ValidateBulkUpdatequest },
    typeof mutationKey
  >({
    mutationKey,
    mutationFn: async ({ data }) => {
      return validateBulkUpdate(data, config)
    },
  })
}

/**
 * @description Validates CSV content and returns a preview of changes. Returns a validationId that must be used to confirm the updates.
 * @summary Validate bulk product updates (Step 1)
 * {@link /v1/product/validate-bulk-update}
 */
export function useValidateBulkUpdate<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<ValidateBulkUpdatesponse>,
      ResponseErrorConfig<Error>,
      { data: ValidateBulkUpdatequest },
      TContext
    > & { client?: QueryClient }
    client?: Partial<RequestConfig<ValidateBulkUpdatequest>> & {
      client?: typeof fetch
    }
  } = {}
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? validateBulkUpdatey()

  const baseOptions = validateBulkUpdatetions(config) as UseMutationOptions<
    ResponseConfig<ValidateBulkUpdatesponse>,
    ResponseErrorConfig<Error>,
    { data: ValidateBulkUpdatequest },
    TContext
  >

  return useMutation<
    ResponseConfig<ValidateBulkUpdatesponse>,
    ResponseErrorConfig<Error>,
    { data: ValidateBulkUpdatequest },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient
  ) as UseMutationResult<
    ResponseConfig<ValidateBulkUpdatesponse>,
    ResponseErrorConfig<Error>,
    { data: ValidateBulkUpdatequest },
    TContext
  >
}
